<template>
  <div>
    <div data-w-id="c849fe57-e01b-c190-95a4-5c536d04300c" class="preloader">
      <img src="@/assets/images/GENIKES_256x256_72dpi.png" loading="lazy" width="306" data-w-id="95589005-0ae2-56e1-ce7f-485cbdbff096" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.preloader {
  display: flex;
  & img {
    transition: 3s;
    animation: gic-anim 3s;
  }
}
@keyframes gic-anim {
  0% {
    opacity: 1;
  }
  100% {
    transform: translate3d(0px, 0px, 0px) scale3d(0.8, 0.8, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg);
    transform-style: preserve-3d;
    opacity: 0;
  }
}
</style>
